import React, { useState, useRef, useEffect } from "react";
import { List, Image } from "antd";
import { ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import refreshimg from "../../../assets/images/refresh-img.svg";
import carouselLeft from "../../../assets/images/carousel-left.svg";
import carouselRight from "../../../assets/images/carousel-right.svg";
import backrefreshimg from "../../../assets/images/back-refresh-img.svg";
import expand from "../../../assets/images/expand.svg";

const ImageList = (props) => {
  const [zoomLevel, setZoomLevel] = useState(100);
  const [rotationDegree, setRotationDegree] = useState(0);

  const imageRef = useRef(null);

  const {imageList, current, onChange, currentIndex} = props;
  const moveRight = () => {
    document.querySelector('.ant-list-items').scrollLeft += 20;
  };
  const moveLeft = () => {
    document.querySelector('.ant-list-items').scrollLeft -= 20;
  };
  useEffect(() => {
    if (imageRef.current) {
      const container = imageRef.current.parentElement;
      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;
      const imageWidth = imageRef.current.clientWidth;
      const imageHeight = imageRef.current.clientHeight;

      if (imageWidth > containerWidth || imageHeight > containerHeight) {
        const widthRatio = containerWidth / imageWidth;
        const heightRatio = containerHeight / imageHeight;
        const newZoomLevel = Math.min(widthRatio, heightRatio) * 100;
        setZoomLevel(newZoomLevel);
      }
    }
  }, [current]);

  const handleZoomIn = () => {
    if (zoomLevel < 200) {
      setZoomLevel(zoomLevel + 10);
    }
  };

  const handleZoomOut = () => {
    if (zoomLevel > 50) {
      setZoomLevel(zoomLevel - 10);
    }
  };

  const handleZoomReset = () => {
      setZoomLevel(100);
  };

  const handleRotateRight = () => {
    setRotationDegree((rotationDegree + 90) % 360);
  };

  const handleRotateLeft = () => {
    setRotationDegree((rotationDegree - 90 + 360) % 360);
  };

  return (
    <div>
      <div className="text-center pl35 pr35">
        {current && (
          <div className="image-viewer-invoicedetails">
            <div className="d-flex align-items-center justify-content-center"
              style={{
                width: "100%",
                height: "100%",
                overflow: "auto",
              }}
              ref={imageRef}
            >
              <img
                src={current}
                alt="Invoice document"
                style={{
                  maxWidth: `${zoomLevel}%`,
                  maxHeight: `${zoomLevel}%`,
                  // transformOrigin: "top left",
                  // transition: "transform 0.3s",
                  transform: `rotate(${rotationDegree}deg)`,
                }}
                className="image-viewer-pdf-image"
              />
            </div>
            <div className="image-viewer-icons">
              <span className="zoom-icons cursor-pointer">
                <ZoomInOutlined onClick={handleZoomIn} width={12} height={12} />
              </span>
              <span className="zoom-icons mx-3 cursor-pointer">
                <ZoomOutOutlined onClick={handleZoomOut} width={12} height={12} />
              </span>
              <span className="text-white fs16 mx-2">
                {zoomLevel}%
              </span>
              <img
                src={refreshimg}
                alt="rotate-right"
                className="mx-2 cursor-pointer"
                onClick={handleRotateLeft}
              />
              <img
                src={backrefreshimg}
                alt="rotate-left"
                className="mx-2 cursor-pointer"
                onClick={handleRotateRight}
              />
              <img
                src={expand}
                alt="expand"
                className="ms-2 cursor-pointer"
                onClick={handleZoomReset}
              />
            </div>
          </div>
        )}
      </div>
      <div className="imageviewer-lists">
        <List
          dataSource={imageList}
          renderItem={(item, index) => (
            <List.Item>
              <Image
                preview={false}
                width={75}
                height={75}
                src={item.image_url}
                alt={'Invoice document'}
                onClick={() => onChange(item.id)}
                className={`imageviewer-image ${index === currentIndex - 1 ? 'selected-border' : ''}`}
              />
              <span className="bluedot-span">{index + 1}</span>
            </List.Item>
          )}
        />

        <button className="arrow arrow-left" onClick={moveLeft}>
          <img
            src={carouselLeft}
            alt="left arrow"
          />
        </button>
        <button className="arrow arrow-right" onClick={moveRight}>
          <img
            src={carouselRight}
            alt="right arrow"
          />
        </button>
      </div>
    </div>
  );


};

export default ImageList;
